module.exports = __webpack_public_path__ + "images/application/templates/reset-password-22c91574.png";